@if (showDropDown) {
  <div class="backdrop"></div>
}

<div style="position: relative;padding: 0 0.938rem;" (mouseleave)="showDropDown=false">

  <!-- menu cat niv 1-->
  <nav class="category-menu" #trigger>
    <ul>
      @for (cat of categories; track cat) {
        <li>
          @if (cat.category.isVisible) {
            <div
              class="category"
              [ngClass]="{'invisible-cat': hoveredCatId === cat.category.id && showDropDown && cat.category.isVisible}"
              (click)="!tablet && navigate2(cat.category.label, cat.category.id!, '')"
              (mouseenter)="handleMouseEnter(cat)">
              <span>{{cat.category.label}}</span>
            </div>
          } @else {
            <div class="category"
              [ngClass]="{'invisible-cat': hoveredCatId === cat.category.id && showDropDown && cat.category.isVisible}"
              (click)="!tablet && navigate2(cat.category.label, cat.category.id!,'')"
              (mouseenter)="selectedCategory = cat; showDropDown = true; hoveredCatId = cat.category.id!; selectedSubCategory = cat.subCategories[0];">
              <span>{{cat.category.label}}</span>
            </div>
          }
        </li>
      }
      @if (!categories.length) {
        <ng-container class="wrapper">
          @for (i of [1, 2, 3, 4, 5, 6, 7]; track i) {
            <li>
              <div class="btn-shimmer animate"></div>
            </li>
          }
        </ng-container>
      }
    </ul>
  </nav>

  <!-- drop down -->
  @if (selectedCategory) {
    <div class="drop-down" [ngClass]="{'drop-down-after': showDropDown}">
      <div class="drop-down-block" [ngStyle]="{'width.px' : maxWidth, 'max-width.px' : maxWidth}">
        <ul class="sub-cat-conatiner">
          <!-- category niv 2 -->
          @for (subCat of selectedCategory.subCategories; track subCat) {
            <li
              (mouseup)="subCategoryHoveredId = subCat.category.id;"
              (click)="selectSubCat(subCat)">
              <!-- category niv 2  label -->
              <a class="sub-cat-label"
                (click)="navigate2(selectedCategory.category.label, selectedCategory.category.id!,subCat.category.label,subCat.category.id)">
                {{subCat.category.label}}
              </a>
              <!-- category niv 3 -->
              <div class="sub-sub-cat-container">
                @if (subCategoryHoveredId === subCat.category.id && seeMore) {
                  @for (subsubcat of subCat.subCategories; track subsubcat) {
                    <div class="cat-item" [ngClass]="{'cat-item-disabled':subsubcat.category.numberOfProducts==0}"
                      >
                      <!-- category niv 3 -->
                      <a
                        (click)="navigate(selectedCategory.category.label, selectedCategory.category.id!,subCat.category.label,subCat.category.id!,subsubcat.category.id!)"
                        class="sub-sub-cat-label">
                        {{subsubcat.category.label}}
                      </a>
                    </div>
                  }
                  <a class="see-more" (click)="this.seeMore = !this.seeMore;"> {{ 'globalUi.menu.seeLess' | translate }} </a>
                } @else {
                  @for (subsubcat of subCat.subCategories.slice(0, 7); track subsubcat; let i = $index) {
                    <div class="cat-item" [ngClass]="{'cat-item-disabled':subsubcat.category.numberOfProducts == 0 }"
                      >
                      <!-- sub sub cat label -->
                      <a class="sub-sub-cat-label"
                        (click)="navigate(selectedCategory.category.label, selectedCategory.category.id!,subCat.category.label,subCat.category.id!,subsubcat.category.id!)">
                        {{subsubcat.category.label}}
                      </a>
                    </div>
                  }
                  @if (subCat.subCategories.length > 7) {
                    <a class="see-more" (click)="this.seeMore = !this.seeMore;">
                      {{ 'globalUi.menu.seeMore' | translate }}
                    </a>
                  }
                }
              </div>
            </li>
          }
        </ul>
      </div>
    </div>
  }
</div>
